import React from "react";
import { useFormContext } from "react-hook-form";
import { InputLabel } from "../InputLabel/InputLabel";
import { InputErrorMessage } from "../InputErrorMessage/InputErrorMessage";

export interface PaziaTextareaProps {
  name: string;
  label?: string;
  required?: boolean;
  disabled?: boolean;
  hidden?: boolean;
  className?: string;
  textareaClassName?: string;
  requiredMessage?: string;
  placeholder?: string;
  value?: any;
  rows?: number;
  onChange?: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  onBlur?: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
}

export const PaziaTextarea = ({
  name,
  label,
  disabled,
  required,
  className = "",
  textareaClassName = "",
  value,
  onBlur,
  onChange,
  hidden,
  placeholder,
  rows = 2,
}: PaziaTextareaProps): JSX.Element => {
  const { register } = useFormContext();

  const {
    onBlur: onBlurRegister,
    onChange: onChangeRegister,
    ...registerRest
  } = register(name);

  const onBlurHandler = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    if (onBlur) onBlur(e);
    onBlurRegister(e);
  };
  const onChangeHandler = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    if (onChange) onChange(e);
    onChangeRegister(e);
  };

  const additionalInputClasses = disabled ? classNames.disabled : "";
  return (
    <div className={`${className ?? ""}`}>
      <InputLabel label={label} required={required} name={name} />
      <textarea
        id={name}
        hidden={hidden}
        className={`form-input w-full ${additionalInputClasses} dark:bg-slate-800 border-border bg-survey-bg text-subheading 
        focus:border-border-highlight block w-full rounded-md border p-2 shadow-sm focus:ring-0 sm:text-sm ${textareaClassName}`}
        disabled={disabled}
        rows={rows}
        value={value}
        placeholder={placeholder}
        onChange={onChangeHandler}
        onBlur={onBlurHandler}
        {...registerRest}
      />
      <InputErrorMessage name={name} />
    </div>
  );
};

const classNames = {
  disabled:
    "disabled:border-slate-200 dark:disabled:border-slate-700 disabled:bg-slate-100 dark:disabled:bg-slate-700 disabled:text-slate-400 dark:disabled:text-slate-600 disabled:cursor-not-allowed",
};
